<template>
  <div id="bodyWrapper">
    <the-header
      tour
    />
    <the-drawer/>
    <slot />
    <the-footer />
  </div>
</template>

<script>
import { TheHeader, TheFooter, TheDrawer } from '@ota-frontend/ui'

export default {
  components: {
    TheFooter,
    TheHeader,
    TheDrawer,
  },
}
</script>
